import { getFieldLabels, type AssetTypeId } from '@/features/funding-sources';

/**
 * Field labels for the selected asset type. Income-stream types append the
 * reference age to the "current value" label so the user understands which
 * year of income they're entering.
 */
export function deriveFieldLabels({
  selectedAssetType,
  isIncomeStream,
  currentReferenceAge,
  ltcAtAge,
}: {
  selectedAssetType: AssetTypeId | 'other';
  isIncomeStream: boolean;
  currentReferenceAge: number | null;
  ltcAtAge: number | null | undefined;
}) {
  if (selectedAssetType === 'other') return null;
  const labels = getFieldLabels(selectedAssetType);
  if (isIncomeStream && currentReferenceAge != null) {
    return {
      ...labels,
      currentValue: {
        ...labels.currentValue,
        label:
          currentReferenceAge === ltcAtAge
            ? `${labels.currentValue.label} (age ${currentReferenceAge})`
            : `Annual income at age ${currentReferenceAge}`,
      },
    };
  }
  return labels;
}
